import React from 'react';
import Alert from '../../components/Form/Alert';

const Success = () => (
  <div className="container mt-5">
    <h1 className="mb-5">E-pasta apstiprināšana.</h1>
    <Alert type="success" label={null}>
      Nosūtījām jums apstiprināšanas E-pastu.<br/> Lai turpinātu klikšķiniet uz saites E-pastā.
    </Alert>
  </div>
);

export default Success;


// WEBPACK FOOTER //
// ./src/scenes/Reset/Success.js